function expandSelfClosingTags(xml) {
  return xml.replaceAll(/<br ?\/>/g, "<br>").replaceAll(
    /<([^\s<>]*)([^<>]*?) *\/>/g,
    (_, tagName, attributes) => `<${tagName} ${attributes}></${tagName}>`
  );
}

export { expandSelfClosingTags };
//# sourceMappingURL=xml.expand-self-closed-tags.js.map
